import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import pluralize from 'pluralize';
import ReactSlider from 'react-slider';
import Modal from 'react-modal';
import { HashLink as Link } from 'react-router-hash-link';
import * as actions from './redux/actions';

import immoquipoAppImg from '../../images/header.png';
import importDatabaseImg from '../../images/import-database.png';
import analyticsImg from '../../images/analytics-img.png';
import analyticsData from '../../images/analytics-data.png';
import logoShare from '../../images/logo-share.png';

import Header from '../common/Header';
import Footer from '../common/Footer';
import InputField from '../common/InputField';

import config from '../../config';

export class DefaultPage extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor() {
    super();

    this.state = {
      messageHasBeenSent: false,
      unitNumber: 0,

      company: '',
      firstname: '',
      lastname: '',
      position: '',
      email: '',
      message: '',
    }

    this.sendMail = this.sendMail.bind(this);
    this.onChangeInput = this.onChangeInput.bind(this);
    this.onUnitRange = this.onUnitRange.bind(this);

    this.onContact = this.onContact.bind(this);
    this.closeContactModal = this.closeContactModal.bind(this);
    this.messageHasBeenSentBtn = this.messageHasBeenSentBtn.bind(this);
  }

  componentDidMount() {
    window.dispatchEvent(new Event('resize'));
  }

  onChangeInput(value, field) {
    this.setState({
      [field]: value,
      [`${field}Error`]: null,
    });
  }

  onUnitRange(value) {
    const { unitNumber } = this.state;
    this.setState({ unitNumber: 500 * Number(value) })

    // used to fix the ReactSlider
    if (unitNumber === 0) { window.dispatchEvent(new Event('resize')) }
  }

  async sendMail(event) {
    event.preventDefault();
    const { actions } = this.props;
    const regexEmail = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
    const {
      company,
      firstname,
      lastname,
      position,
      email,
      message,
    } = this.state;
    const errorData = {};

    if (!company) { errorData.companyError = 'Veuillez entrer un nom de société.' }
    if (!firstname) { errorData.firstnameError = 'Veuillez entrer un prénom.' }
    if (!lastname) { errorData.lastnameError = 'Veuillez entrer un nom.' }
    if (!position) { errorData.positionError = 'Veuillez entrer votre fonction.' }
    if (!message) { errorData.messageError = 'Veuillez entrer un message.' }
    if (!regexEmail.test(email)) { errorData.emailError = 'Veuillez entrer un email valide.' }
    if (!email) { errorData.emailError = 'Veuillez entrer un email.' }

    if (_.isEmpty(errorData)) {
      actions.sendMail({
        data: {
          company,
          firstname,
          lastname,
          position,
          email,
          message,
        }
      })
      this.setState({ messageHasBeenSent: true })
    } else {
      this.setState({ ...errorData })
    }
  }

  onContact() {
    this.setState({
      isContactModalOpen: true,
    })
  }

  closeContactModal() {
    this.setState({
      isContactModalOpen: false,
    })
  }

  messageHasBeenSentBtn() {
    this.setState({
      isContactModalOpen: false,
      messageHasBeenSent: false,
    })
  }

  render() {
    const {
      messageHasBeenSent,
      unitNumber,
      
      company,
      firstname,
      lastname,
      position,
      email,
      message,

      companyError,
      firstnameError,
      lastnameError,
      positionError,
      emailError,
      messageError,

      isContactModalOpen,
    } = this.state;

    return (
      <div className="home-default-page">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Immoquipo - Donnez sens à vos données immobilières</title>
          <meta name="description" content="Immoquipo vous aide à trouver vos potentiels vendeurs immobilier à partir de vos données et cela en toute sécurité. Donnez de la valeur à vos données immobilières. Notre algorithme d'intelligence artificielle identifie les copropriétaires vendeurs dans votre portefeuille." />
          <meta content={logoShare} property="og:image" />
          <meta name="keywords" content="immobilier, prediction, vente, lot, mutation, copropriétaire, syndic, maison, appartement" />
          <link rel="canonical" href="https://immoquipo.com" />
        </Helmet>
        <Header onContact={this.onContact} />
        <div className="header">
          <div className="header-content">
            <div className="header-title">
              <h2 className="title">Trouvez vos potentiels vendeurs immobilier à partir de vos données</h2>
              <button className="button-link" onClick={this.onContact}>Contactez-nous</button>
            </div>
            <div className="header-media">
              <img className="app-img" src={immoquipoAppImg} alt="immoquipo-app" />
              <p className="description">
                Ne passez plus jamais à côté d'une transaction immobilière
              </p>
            </div>
          </div>
        </div>
        <div className="slider-content">
          <h3 className="title">“Les administrateurs de biens passent à côté de près de 90% de transactions”</h3>
          <p className="subtitle">Donnez de la valeur à vos données immobilières et cela en toute sécurité.</p>
          <div className="slider-wrapper">
            <div className="slider-details">
              <p className="units-number">{unitNumber} {pluralize('lot', unitNumber || 1)} </p>
              <p className="sales-number">~ {Math.round(unitNumber / 63)} {pluralize('vente', unitNumber || 1)} / an</p>
            </div>
            <ReactSlider
                max={200}
                style={{width: '600px'}}
                className="horizontal-slider"
                thumbClassName="slider-thumb"
                trackClassName="slider-track"
                step={1}
                forceResize
                onChange={this.onUnitRange}
            />
            <p className="amount-sales">Soit <span className="orange-main-color">{Math.round(unitNumber / 63 * 12500 / 1000000 * 100) / 100}M €</span> de commissions</p>
            <p className="info-sales">avec une moyenne de 12 500€ d’honoraires par mission</p>
          </div>
        </div>
        <div id="le-concept" className="concept-content">
          <div className="concept-wrapper">
            <div className="concept-block">
              <div className="text-content">
                <div className="number">1</div>
                <h4 className="concept-title">Importez votre données</h4>
                <p className="concept-description">Importez directement vos données en <span className="bold-main">CSV ou XLSX</span>, grâce à notre système qui permet de mapper/correspondre n’importe quel CSV pour qu’ainsi nous puissions traiter vos données</p>
              </div>
              <img className="img-concept" src={importDatabaseImg} alt="database-upload" />
            </div>
          </div>
          <div className="concept-wrapper">
          <div className="concept-block left">
            <img className="img-concept" src={analyticsImg} alt="database-upload" />
            <div className="text-content">
              <div className="number">2</div>
              <h4 className="concept-title">Nous analysons</h4>
              <p className="concept-description">Grâce à des algorithmes de machine learning ainsi que du savoir-faire dans l’analyse de comportement humains, nous avons créer <span className="bold-main">une super intelligence permettant de déduire des prédictions de transactions immobilières.</span> On analyse également la population de l’échantillon importé pour prédire l'évolution de celle-ci.</p>
            </div>
          </div>
          </div>
          <div className="concept-wrapper">
          <div className="concept-block">
            <div className="text-content">
              <div className="number">3</div>
              <h4 className="concept-title">Vous avez des données analysées et qualifiées</h4>
              <p className="concept-description">Les données recueillies pourront directement être utilisées par votre service marketing, ou pour tout simplement analyser votre population de clients: <span className="bold-main">prédire leurs prochaines actions dans l’immobilier</span> et ainsi réagir en adéquation.</p>
            </div>
            <img  className="img-concept" src={analyticsData} alt="database-upload" />
          </div>
          </div>
        </div>
        <div id="comment-ca-marche" className="how-it-works">
          <h3 className="how-it-works-title">Comment ça marche ?</h3>
          <div className="how-it-works-content">
            <div className="deep-learning">
              <h4 className="how-it-works-subtitle"><span className="icon-deep-learning"></span> Deep Learning</h4>
              <p className="how-it-works-text">Nous utilisons <span className="bold">un système prédictif basé sur du deep-learning.</span> Le système est tout d’abord entraîné sur <span className="bold">une grande base de données qui regroupe les ventes et mises en locations de biens par des copropriétaires</span> chez différents acteurs du monde de l’immobilier.</p><br />
              <p className="how-it-works-text"><span className="bold">Le système va apprendre</span> à reconnaître des caractéristiques précises qui amènent un copropriétaire à vendre ou non.</p><br />
              <p className="how-it-works-text">De ce fait, il sera capable de prendre en entrée un copropriétaire et de <span className="bold">retourner en sortie une probabilité de vente</span> de ses biens (phase de prédiction).</p><br />
              <p className="how-it-works-text">Afin d’évaluer le système la base de données sera découpée en 80% - 20% où <span className="bold">les 80% servent à l’entraînement du système et les 20% restant à son évaluation.</span></p>
            </div>
            <div className="security">
              <h4 className="how-it-works-subtitle"><span className="icon-security"></span> Private by design</h4>
              <p className="how-it-works-text">Dans un métier où les données sont sensibles et très importantes, <span className="bold">nous ne voulons jamais avoir les données de nos clients mélangés.</span></p>
              <p className="how-it-works-text">En effet, chaque entreprise aura <span className="bold">un serveur dédié ou la possibilité de choisir son propre serveur</span> sur lequel nous installerions une license d’immoquipo.</p>
              <p className="how-it-works-text">Possibilité de créer des projets avec <span className="bold">des gestions de droits sur les collaborateurs</span></p>
              <p className="how-it-works-text">Possibilité d’avoir <span className="bold">un super admin</span> (personne qui peut tout contrôler)</p>
              <p className="how-it-works-text"><span className="bold">Données encryptées</span>, avec des possibilités d’anonymisations</p>
            </div>
          </div>
        </div>
        <Footer onContact={this.onContact} />
        <Modal
          isOpen={isContactModalOpen}
          onRequestClose={this.closeContactModal}
          style={config.defaultModalStyles}
          ariaHideApp={false}
          className="contact-modal"
          contentLabel="Contact"
        >
          {!messageHasBeenSent &&
            <form className="contact-form">
              <h3 className="contact-title">Contactez-nous</h3>
              <InputField value={company} errorMessage={companyError} onChange={(value) => { this.onChangeInput(value, 'company')}} label="Société*" type="text" />
              <InputField value={firstname} errorMessage={firstnameError} onChange={(value) => { this.onChangeInput(value, 'firstname')}} label="Prénom*" type="text" />
              <InputField value={lastname} errorMessage={lastnameError} onChange={(value) => { this.onChangeInput(value, 'lastname')}} label="Nom*" type="text" />
              <InputField value={position} errorMessage={positionError} onChange={(value) => { this.onChangeInput(value, 'position')}} label="Fonction*" type="text" />
              <InputField value={email} errorMessage={emailError} onChange={(value) => { this.onChangeInput(value, 'email')}} label="Email*" type="text" />
              <InputField value={message} errorMessage={messageError} onChange={(value) => { this.onChangeInput(value, 'message')}} label="Message*" type="textarea" />
              <button onClick={this.sendMail} className="contact-btn">Envoyer</button>
            </form>
          }
          {messageHasBeenSent && 
            <div className="message-has-been-sent">
              <p>Votre message a bien été envoyé.</p>
              <p>Nous reviendrons vers vous dès que possible.</p>
              <br />
              <button onClick={this.messageHasBeenSentBtn} className="contact-btn">Fermer</button>
            </div>
          }
        </Modal>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js